import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import Login from '@/views/login.vue';
import Dashboard from '@/views/dashboard.vue';
import APIKeys from '@/views/apikeys.vue';
import APIRequests from '@/views/apirequests.vue';
import Users from '@/views/users.vue';
import PhoneValidations from '@/views/phone_val.vue';
import IDValidations from '@/views/id_val.vue';
import NinMatchValidations from '@/views/nin_match_val.vue';
import KYCValidations from '@/views/kyc_val.vue';
import Ledger from '@/views/ledger.vue';
import Organizations from '@/views/organizations.vue';
import TopUpRequests from '@/views/topup-requests.vue';
import OrganizationDetail from '@/views/organization_detail.vue';
import Services from '@/views/services.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard,
  },
  {
    path: '/apikeys',
    name: 'apikeys',
    component: APIKeys,
  },
  {
    path: '/apirequests',
    name: 'apirequests',
    component: APIRequests,
  },
  {
    path: '/user-mgt',
    name: 'users',
    component: Users,
  },
  {
    path: '/validations/phone',
    name: 'phone-validations',
    component: PhoneValidations,
  },
  {
    path: '/validations/id',
    name: 'id-validations',
    component: IDValidations,
  },
  {
    path: '/validations/id-match',
    name: 'id-match-validations',
    component: NinMatchValidations,
  },
  {
    path: '/validations/kyc',
    name: 'kyc-validations',
    component: KYCValidations,
  },
  {
    path: '/billing/ledger',
    name: 'ledger',
    component: Ledger,
  },
  {
    path: '/management/organizations',
    name: 'organizations',
    component: Organizations,
  },
  {
    path: '/management/topup-requests',
    name: 'topup-requests',
    component: TopUpRequests,
  },
  {
    path: '/management/organizations/:id',
    name: 'organization-detail',
    component: OrganizationDetail,
  },
  {
    path: '/management/services',
    name: 'services',
    component: Services,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token');

  if (to.path === '/login') {
    if (token) {
      next('/dashboard');
    } else {
      next();
    }
  } else if (token) {
    next();
  } else {
    next('/login');
  }
});

export default router;
